























import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_municipalitySelections_currentUnit_municipalitySelections } from '@/queries/__generated__/municipalitySelections';
import MunicipalitySelectionShow from '@/components/Municipality/MunicipalitySelectionShow.vue';

@Component({
  components: {
    MunicipalitySelectionShow,
  },
})
export default class MunicipalitySelectionShowButton extends Vue {
  @Prop() private municipalitySelection!: GQL_municipalitySelections_currentUnit_municipalitySelections;
  private showDialog = false;
}
